import { render, staticRenderFns } from "./MailSendField.vue?vue&type=template&id=6576072a"
import script from "./MailSendField.ts?vue&type=script&lang=ts&external"
export * from "./MailSendField.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports